export default __webpack_public_path__ + "static/media/transfusion-typeY.0b1cf063.jpg";